window.MECatalog = {
  families: {
    "family-1007": {
      supplier: "supplier-af",
      label: "1007 Youth Premium Tee",
      collectionHandle: "1007-youth-premium-tee",
      colors: [
        { name: "Black", handle: "1007-youth-premium-tee-black" },
        { name: "White", handle: "1007-youth-premium-tee-white" },
        { name: "Turquoise", handle: "1007-youth-premium-tee-turquoise" },
        { name: "Sports Grey", handle: "1007-youth-premium-tee-sports-grey" },
        { name: "Royal", handle: "1007-youth-premium-tee-royal" },
        { name: "Red", handle: "1007-youth-premium-tee-red" },
        { name: "Purple", handle: "1007-youth-premium-tee-purple" },
        { name: "Pacific Blue", handle: "1007-youth-premium-tee-pacific-blue" },
        { name: "Orange", handle: "1007-youth-premium-tee-orange" },
        { name: "Navy", handle: "1007-youth-premium-tee-navy" },
        { name: "Moss Green", handle: "1007-youth-premium-tee-moss-green" },
        { name: "Mint", handle: "1007-youth-premium-tee-mint" },
        { name: "Hot Pink", handle: "1007-youth-premium-tee-hot-pink" },
        { name: "Gold", handle: "1007-youth-premium-tee-gold" },
        { name: "Dust", handle: "1007-youth-premium-tee-dust" },
        { name: "Dark Navy", handle: "1007-youth-premium-tee-dark-navy" },
        { name: "Charcoal Heather", handle: "1007-youth-premium-tee-charcoal-heather" },
        { name: "Burgundy", handle: "1007-youth-premium-tee-burgundy" },
        { name: "Baby Pink", handle: "1007-youth-premium-tee-baby-pink" }
      ]
    }
  }
};